import { getAppIdDocId } from "@porchpass/api-client";
import { assertApiSuccess } from "../utils/assertApiSuccess";
import { fetchApi } from "../utils/fetchApi";

export function createDocumentsDomain() {
  return {
    getApplicationDocument: async (
      applicationId: string,
      documentId: string,
    ): Promise<Blob> => {
      const response = await getAppIdDocId(applicationId, documentId);
      return assertApiSuccess<Blob>(response);
    },

    getApplicationDocumentArchive: async (
      applicationId: string,
      documentId: string,
    ): Promise<Blob> => {
      const response = await fetchApi<Blob>(
        `/${applicationId}/${documentId}?as_archive=true`,
        { method: "GET" },
      );
      return response.data;
    },
  };
}
